import { CatalogueLang } from "../lang/CatalogueLang";
import { HomePageLang } from "../lang/HomePageLang";
import { ProductPageLang } from "../lang/ProductPageLang";
import { routeConstant } from "./routeConstant";

export const LUTON_LOGO = "/logo.png";
export const HOME_ABOUT_US_IMG = "/assets/exploreProduct10.jpg";
export const videoUrl = "assets/slidervideo.mp4";

export const EXPLORE_COLLECTIONS = [
  { img: "/assets/exploreProduct1.jpg" },
  { img: "/assets/exploreProduct2.jpg" },
  { img: "/assets/exploreProduct3.jpg" },
  { img: "/assets/exploreProduct4.jpg" },
  { img: "/assets/exploreProduct5.jpg" },
  { img: "/assets/exploreProduct6.jpg" },
  { img: "/assets/exploreProduct7.jpg" },
  { img: "/assets/exploreProduct8.jpg" },
  { img: "/assets/exploreProduct9.jpg" },
  { img: "/assets/exploreProduct10.jpg" },
];

export const WHAT_MAKES_US_BEST = [
  {
    id: 1,
    title: HomePageLang.DIGITAL_PARKING_TILES,
    description: HomePageLang.DIGITAL_PARKING_TILES_DESC,
    image: "/assets/exploreProduct8.jpg",
  },
  {
    id: 2,
    title: HomePageLang.GLOBAL_EXPORT_NETWORK,
    description: HomePageLang.GLOBAL_EXPORT_NETWORK_DESC,
    image: "/exportNetwork/exportarea.webp",
  },
  {
    id: 3,
    title: HomePageLang.ROBUST_INFRASTRUCTURE,
    description: HomePageLang.ROBUST_INFRASTRUCTURE_DESC,
    image: "/infrastructure/infra3.jpg",
  },
  {
    id: 4,
    title: HomePageLang.INNOVATION_QUALITY_CONTROL,
    description: HomePageLang.INNOVATION_QUALITY_CONTROL_DESC,
    image: "/exportNetwork/innovation.webp",
  },
  {
    id: 5,
    title: HomePageLang.END_TO_END_SUPPORT,
    description: HomePageLang.END_TO_END_SUPPORT_DESC,
    image: "/exportNetwork/support.webp",
  },
];

export const INFRASTRUCTURE_IMAGES = "/infrastructure/infra2.jpg";


export const APPLICATION_AREAS = [
  {
    image: "/application_area/hospital.png",
    caption: HomePageLang.HOSPITAL,
  },
  {
    image: "/application_area/mall.png",
    caption: HomePageLang.MALL,
  },
  {
    image: "/application_area/office.png",
    caption: HomePageLang.OFFICE,
  },
  {
    image: "/application_area/supermarket.png",
    caption: HomePageLang.SUPERMARKET,
  },
  {
    image: "/application_area/airport.png",
    caption: HomePageLang.AIRPORT,
  },
  {
    image: "/application_area/factory.png",
    caption: HomePageLang.FACTORY,
  },
];


export const COUNT_BANNER_1 = "/assets/exploreProduct7.jpg";
export const COUNT_BANNER_2 = "/assets/exploreProduct3.jpg";

export const COUNT_SECTION = [
  {
    number: HomePageLang.HAPPY_CLIENTS_COUNT,
    label: HomePageLang.HAPPY_CLIENTS,
  },
  {
    number: HomePageLang.PRODUCT_DESIGNS_COUNT,
    label: HomePageLang.PRODUCT_DESIGNS,
  },
  {
    number: HomePageLang.YEARS_OF_EXPERIENCE_COUNT,
    label: HomePageLang.YEARS_OF_EXPERIENCE,
  },
  {
    number: HomePageLang.EXPORT_COUNTRIES_COUNT,
    label: HomePageLang.EXPORT_COUNTRIES,
  },
];

export const GLOBAL_FOOTPRINT_IMG = "/exportNetwork/exportarea.webp";

export const AVIDANCE_DATA = [
  {
    title: HomePageLang.COMAPNY,
    image: "assets/lutonceramic.webp",
    link: routeConstant.ABOUT,
  },
  {
    title: HomePageLang.GLOBAL_NETWORK,
    image: "exportNetwork/globalnetwork.webp",
    link: routeConstant.EXPORT,
  },
  {
    title: HomePageLang.COLLECTION,
    image: "assets/exploreProduct3.jpg",
    link: routeConstant.COLLECTION,
  },
  {
    title: HomePageLang.CATALOUGE,
    image: "catalogues/plainCollection.jpg",
    link: routeConstant.CATALOGUE_400X400,
  },
];

export const ABOUT_MAIN = "/slider/slider9.jpg";
export const ABOUT_SIDE = "/assets/lutonceramic.webp";
export const ABOUT_COMPANY_PROFILE = "/assets/LutonCertificate.jpg";
export const MADE_IN_INDIA = "/assets/made_in_india.webp";

export const ABOUT_WHY_LUTON = [
  {
    img: "/assets/variety.png",
    title: "Variety",
    desc: "We bring you a grand collection of tiles that are available in various sizes. These tiles are designed to create grand urban spaces with their incredible designs and exceptional styles.",
  },
  {
    img: "/assets/multipleformats.png",
    title: "Multiple Formats",
    desc: "Our tiles provide the ideal size that can be installed in all types of big and small places. These tiles are designed keeping in mind the requirement of modern interior design style.",
  },
  {
    img: "/assets/parking_tiles.jpg",
    title: "The Pursuit of Excellence",
    desc: "We provide a complete tiling solution with our tiles that are easily applicable to many residential as well as commercial spaces.",
  },
  {
    img: "/assets/authenticity.webp",
    title: "Authenticity",
    desc: "We do not use low-quality materials to win the price game over others in the market. This makes us the leading tile company in the nation.",
  },
  {
    img: "/assets/honesty.webp",
    title: "Honesty",
    desc: "Our employees and teammates are honest with you. If there's a shortcoming, we will inform you priorly. Our honesty has helped us sustain and make a remarkable impact in the tile manufacturing industry.",
  },
  {
    img: "/assets/price_flexibility.webp",
    title: "Price Flexibility",
    desc: "We believe our ceramic products must be available for everyone. We are flexible at pricing and have a diverse range of ceramic products to fit your budget.",
  },
  {
    img: "/assets/ourValue.webp",
    title: "Best Quality",
    desc: "Supreme quality is the key to success in the long run. We never compromise on quality and use top-quality materials to maintain our global reputation.",
  },
  {
    img: "/assets/innovation.webp",
    title: "Innovation",
    desc: "We constantly strive to bring in new designs and patterns with subtle colors to make your home or office look elegant and charming.",
  },
  {
    img: "/assets/packaging.jpg",
    title: "Packaging",
    desc: "We take extra precautions while packaging our ceramic products so they arrive safely and securely without any damage in transit.",
  },
];

export const TECHINCAL_SPECIFICATION_IMG = "/assets/technicalSpecification.png";

export const INFRASTRUCTURE_ALL_IMAGES = [
  "/infrastructure/infra1.jpg",
  "/infrastructure/infra2.jpg",
  "/infrastructure/infra3.jpg",
  "/infrastructure/infra4.jpg",
  "/assets/lutonceramic.webp",
  "/infrastructure/infra5.jpg",
  "/infrastructure/infra6.png",
  "/infrastructure/infra7.jpg",
  "/infrastructure/infra8.jpg",
];
export const PRODUCT_MAIN = "/slider/slider5.jpg";

export const COLLECTION_ITEM = [
  {
    img: "/assets/CardImg400_400.png",
    title: ProductPageLang.PRODUCT_1,
    link: routeConstant.PRODUCT_400x400,
  },
  {
    img: "/assets/CardImg500_500.png",
    title: ProductPageLang.PRODUCT_2,
    link: routeConstant.PRODUCT_500x500,
  },
];

export const CATALOGUE_ITEM = [
  {
    img: "/catalogues/plainCollection.jpg",
    title: CatalogueLang.CATALOGUE_1,
    link: routeConstant.CATALOGUE_400X400,
  },
  {
    img: "/catalogues/punchSeries.png",
    title: CatalogueLang.CATALOGUE_2,
    link: routeConstant.CATALOGUE_500X500,
  },
  {
    img: "/catalogues/eCatalogue.png",
    title: CatalogueLang.E_CATALOGUE,
    link: routeConstant.E_CATALOGUE,
  },  
];

export const EXPORT_MAIN = "/exportNetwork/exportMain.webp";
export const EXPORT_NETWORK_CARD = "/exportNetwork/exportCard.webp";

export const GULF_COUNTRY = [
  { name: "Saudi Arabia", flag: "country/gulfCountry/soudi_arabia.jpg" },
  { name: "Oman", flag: "country/gulfCountry/oman.jpg" },
  { name: "Qatar", flag: "country/gulfCountry/qatar.png" },
  { name: "Bahrain", flag: "country/gulfCountry/bahrain.png" },
  {
    name: "United Arab Emirates",
    flag: "country/gulfCountry/united_arab_emirates.jpg",
  },
];

export const AFRICA_COUNTRY = [
  { name: "South Africa", flag: "country/africaCountry/south_africa.jpg" },
  { name: "Zambia", flag: "country/africaCountry/zambia.jpg" },
  { name: "Tanzania", flag: "country/africaCountry/tanzania.jpg" },
  { name: "Kenya", flag: "country/africaCountry/kenya.jpg" },
  { name: "Somalia", flag: "country/africaCountry/somalia.jpg" },
  { name: "Congo", flag: "country/africaCountry/congo.jpg" },
  { name: "Angola", flag: "country/africaCountry/angola.jpg" },
  { name: "Cote d’ivoire", flag: "country/africaCountry/cote_d_ivoire.jpg" },
  { name: "Nigeria", flag: "country/africaCountry/nigeria.jpg" },
  { name: "Chad", flag: "country/africaCountry/chad.jpg" },
  { name: "Libya", flag: "country/africaCountry/libya.jpg" },
  { name: "Cameroon", flag: "country/africaCountry/cameroon.jpg" },
  { name: "Egypt", flag: "country/africaCountry/egypt.jpg" },
  { name: "Mozambique", flag: "country/africaCountry/mozambique.jpeg" },
  { name: "Senegal", flag: "country/africaCountry/senegal.jpeg" },
  { name: "Guinea", flag: "country/africaCountry/guinea.jpeg" },
  { name: "Burkina Faso", flag: "country/africaCountry/burkina_faso.jpeg" },
  { name: "Ethiopia", flag: "country/africaCountry/ethiopia.jpeg" },
  { name: "Mauritius", flag: "country/africaCountry/mauritius.jpeg" },
];

export const ASIA_COUNTRY = [
  { name: "Vietnam", flag: "country/asiaCountry/vietnam.jpg" },
  { name: "Bhutan", flag: "country/asiaCountry/bhutan.png" },
  { name: "Indonesia", flag: "country/asiaCountry/indonesia.jpg" },
  { name: "Nepal", flag: "country/asiaCountry/nepal.jpeg" },
];

export const EUROPE_COUNTRY = [
  { name: "Bulgaria", flag: "country/europeCountry/bulgaria.jpeg" },
  { name: "Albania", flag: "country/europeCountry/albania.jpeg" },
];
export const CERTIFICATIONS = [
  { src: "/assets/certificate1.png", alt: "Capexil" },
  { src: "/assets/certificate2.png", alt: "Aadhar" },
  { src: "/assets/certificate3.png", alt: "FIEO" },
];

export const CATALOUGE_COLLECTION_400_400 = [
  {
    title: "Plain Collection 1",
    image: "catalogues/plainCollection.jpg",
    pdfPath: "/catalogues/400x400/PLAIN_COLLECTION_1.pdf",
  },
  {
    title: "Plain Collection 2",
    image: "catalogues/plainCollection.jpg",
    pdfPath: "/catalogues/400x400/PLAIN_COLLECTION_2.pdf",
  },
  {
    title: "Light-Dark Collection 1",
    image: "catalogues/lightDark.jpg",
    pdfPath: "/catalogues/400x400/LIGHT_DARK_COLLECTION_1.pdf",
  },
  {
    title: "Light-Dark Collection 2",
    image: "catalogues/lightDark.jpg",
    pdfPath: "/catalogues/400x400/LIGHT_DARK_COLLECTION_2.pdf",
  },
  {
    title: "Light-Dark Collection 3",
    image: "catalogues/lightDark.jpg",
    pdfPath: "/catalogues/400x400/LIGHT_DARK_COLLECTION_3.pdf",
  },
  {
    title: "Punch Collection 1",
    image: "catalogues/punchCollection.png",
    pdfPath: "/catalogues/400x400/PUNCH_COLLECTION_1_1.pdf",
  },
  {
    title: "Punch Collection 2",
    image: "catalogues/punchCollection.png",
    pdfPath: "/catalogues/400x400/PUNCH_COLLECTION_1_2.pdf",
  },
  {
    title: "Punch Collection 3",
    image: "catalogues/punchCollection.png",
    pdfPath: "/catalogues/400x400/PUNCH_COLLECTION_2_1.pdf",
  },
  {
    title: "Punch Collection 4",
    image: "catalogues/punchCollection.png",
    pdfPath: "/catalogues/400x400/PUNCH_COLLECTION_2_2.pdf",
  },
  {
    title: "Punch Collection 5",
    image: "catalogues/punchCollection.png",
    pdfPath: "/catalogues/400x400/PUNCH_COLLECTION_3_1.pdf",
  },
  {
    title: "Punch Collection 6",
    image: "catalogues/punchCollection.png",
    pdfPath: "/catalogues/400x400/PUNCH_COLLECTION_3_2.pdf",
  },
  {
    title: "Gardan Collection 1",
    image: "catalogues/gardenCollection.jpg",
    pdfPath: "/catalogues/400x400/GARDAN_COLLECTION_1.pdf",
  },
  {
    title: "Gardan Collection 2",
    image: "catalogues/gardenCollection.jpg",
    pdfPath: "/catalogues/400x400/GARDAN_COLLECTION_2.pdf",
  },
  {
    title: "Mica Series",
    image: "catalogues/micaSeries.jpg",
    pdfPath: "/catalogues/400x400/MICA_SERIES.pdf",
  },
];

export const CATALOUGE_COLLECTION_500_500 = [
  {
    title: 'Plain Series 1',
    image: '/catalogues/plainSeries.png',
    pdfPath: '/catalogues/500x500/PLAIN_SERIES_1.pdf'
  },
  {
    title: 'Plain Series 2',
    image: '/catalogues/plainSeries.png',
    pdfPath: '/catalogues/500x500/PLAIN_SERIES_2.pdf'
  },
  {
    title: 'Plain Series 3',
    image: '/catalogues/plainSeries.png',
    pdfPath: '/catalogues/500x500/PLAIN_SERIES_3.pdf'
  },
  {
    title: 'Punch Series 1-2-3',
    image: '/catalogues/punchSeries.png',
    pdfPath: '/catalogues/500x500/PUNCH_SERIES_1_2_3.pdf'
  },
  {
    title: 'Punch Series 4',
    image: '/catalogues/punchSeries.png',
    pdfPath: '/catalogues/500x500/PUNCH_SERIES_4.pdf'
  },
  {
    title: 'Punch Series 4-5-6',
    image: '/catalogues/punchSeries.png',
    pdfPath: '/catalogues/500x500/PUNCH_SERIES_4_5_6.pdf'
  },
  {
    title: 'Punch Series 7-8-9',
    image: '/catalogues/punchSeries.png',
    pdfPath: '/catalogues/500x500/PUNCH_SERIES_7_8_9.pdf'
  },
  {
    title: '500x500 New Collection',
    image: '/catalogues/punchSeries.png',
    pdfPath: '/catalogues/500x500/500_500_NEW_COLLECTION.pdf'
  }
];

export const E_CATALOGUE_COLLECTION = [
  {
    title: 'E - Catalogue',
    image: '/catalogues/eCatalogue.png',
    pdfPath: '/catalogues/E_CATALOGUE_13_06_2025.pdf'
  },
];

export const PRODUCT_500_500 = [
  {
    image: "/products/500x500/des_20003.jpg",
    title: "Design No: 20003",
  },
  {
    image: "/products/500x500/des_20004.jpg",
    title: "Design No: 20004",
  },
  {
    image: "/products/500x500/des_20030.jpg",
    title: "Design No: 20030",
  },
  {
    image: "/products/500x500/des_20031.jpg",
    title: "Design No: 20031",
  },
  {
    image: "/products/500x500/des_20209.jpg",
    title: "Design No: 20209",
  },
  {
    image: "/products/500x500/des_20210.jpg",
    title: "Design No: 20210",
  },
  {
    image: "/products/500x500/des_20221.jpg",
    title: "Design No: 20221",
  },
  {
    image: "/products/500x500/des_20222.jpg",
    title: "Design No: 20222",
  },
  {
    image: "/products/500x500/des_20237.jpg",
    title: "Design No: 20237",
  },
  {
    image: "/products/500x500/des_20238.jpg",
    title: "Design No: 20238",
  },
  {
    image: "/products/500x500/des_20301.jpg",
    title: "Design No: 20301",
  },
  {
    image: "/products/500x500/des_20302.jpg",
    title: "Design No: 20302",
  },
  {
    image: "/products/500x500/des_20311.jpg",
    title: "Design No: 20311",
  },
  {
    image: "/products/500x500/des_20312.jpg",
    title: "Design No: 20312",
  },
  {
    image: "/products/500x500/des_20452.jpg",
    title: "Design No: 20452",
  },
  {
    image: "/products/500x500/des_20453.jpg",
    title: "Design No: 20453",
  },
  {
    image: "/products/500x500/des_20454.jpg",
    title: "Design No: 20454",
  },
  {
    image: "/products/500x500/des_20455.jpg",
    title: "Design No: 20455",
  },
  {
    image: "/products/500x500/des_20317.jpg",
    title: "Design No: 20317",
  },
  {
    image: "/products/500x500/des_20318.jpg",
    title: "Design No: 20318",
  },
  {
    image: "/products/500x500/des_20325.jpg",
    title: "Design No: 20325",
  },
  {
    image: "/products/500x500/des_20326.jpg",
    title: "Design No: 20326",
  },
  {
    image: "/products/500x500/des_20804.jpg",
    title: "Design No: 20804",
  },
  {
    image: "/products/500x500/des_20805.jpg",
    title: "Design No: 20805",
  },
  {
    image: "/products/500x500/des_20807.jpg",
    title: "Design No: 20807",
  },
  {
    image: "/products/500x500/des_20808.jpg",
    title: "Design No: 20808",
  },
  {
    image: "/products/500x500/des_20810.jpg",
    title: "Design No: 20810",
  },
  {
    image: "/products/500x500/des_20812.jpg",
    title: "Design No: 20812",
  },
  {
    image: "/products/500x500/des_20957.jpg",
    title: "Design No: 20957",
  },
  {
    image: "/products/500x500/des_20958.jpg",
    title: "Design No: 20958",
  },
  {
    image: "/products/500x500/des_20959.jpg",
    title: "Design No: 20959",
  },
  {
    image: "/products/500x500/des_20960.jpg",
    title: "Design No: 20960",
  },
  {
    image: "/products/500x500/des_21001.jpg",
    title: "Design No: 21001",
  },
  {
    image: "/products/500x500/des_21002.jpg",
    title: "Design No: 21002",
  },
  {
    image: "/products/500x500/des_21005.jpg",
    title: "Design No: 21005",
  },
  {
    image: "/products/500x500/des_21010.jpg",
    title: "Design No: 21010",
  },
  {
    image: "/products/500x500/des_21051.jpg",
    title: "Design No: 21051",
  },
  {
    image: "/products/500x500/des_21053.jpg",
    title: "Design No: 21053",
  },
  {
    image: "/products/500x500/des_21055.jpg",
    title: "Design No: 21055",
  },
  {
    image: "/products/500x500/des_21058.jpg",
    title: "Design No: 21058",
  },
  {
    image: "/products/500x500/des_21102.jpg",
    title: "Design No: 21102",
  },
  {
    image: "/products/500x500/des_21103.jpg",
    title: "Design No: 21103",
  },
  {
    image: "/products/500x500/des_21104.jpg",
    title: "Design No: 21104",
  },
  {
    image: "/products/500x500/des_21106.jpg",
    title: "Design No: 21106",
  },
  {
    image: "/products/500x500/des_21151.jpg",
    title: "Design No: 21151",
  },
  {
    image: "/products/500x500/des_21154.jpg",
    title: "Design No: 21154",
  },
  {
    image: "/products/500x500/des_21156.jpg",
    title: "Design No: 21156",
  },
  {
    image: "/products/500x500/des_21157.jpg",
    title: "Design No: 21157",
  },
  {
    image: "/products/500x500/des_20901.jpg",
    title: "Design No: 20901",
  },
  {
    image: "/products/500x500/des_20902.jpg",
    title: "Design No: 20902",
  },
  {
    image: "/products/500x500/des_20904.jpg",
    title: "Design No: 20904",
  },
  {
    image: "/products/500x500/des_20830.jpg",
    title: "Design No: 20830",
  },
  {
    image: "/products/500x500/des_20852.jpg",
    title: "Design No: 20852",
  },
  {
    image: "/products/500x500/des_20856.jpg",
    title: "Design No: 20856",
  },
  {
    image: "/products/500x500/des_20858.jpg",
    title: "Design No: 20858",
  },
  {
    image: "/products/500x500/des_20859.jpg",
    title: "Design No: 20859",
  },
  {
    image: "/products/500x500/des_20861.jpg",
    title: "Design No: 20861",
  },
  {
    image: "/products/500x500/des_20862.jpg",
    title: "Design No: 20862",
  },
  {
    image: "/products/500x500/des_20863.jpg",
    title: "Design No: 20863",
  },
  {
    image: "/products/500x500/des_20813.jpg",
    title: "Design No: 20813",
  },
  {
    image: "/products/500x500/des_20652.jpg",
    title: "Design No: 20652",
  },
  {
    image: "/products/500x500/des_20655.jpg",
    title: "Design No: 20655",
  },
  {
    image: "/products/500x500/des_20656.jpg",
    title: "Design No: 20656",
  },
  {
    image: "/products/500x500/des_20657.jpg",
    title: "Design No: 20657",
  },
  {
    image: "/products/500x500/des_20551.jpg",
    title: "Design No: 20551",
  },
  {
    image: "/products/500x500/des_20556.jpg",
    title: "Design No: 20556",
  },
  {
    image: "/products/500x500/des_20603.jpg",
    title: "Design No: 20603",
  },
  {
    image: "/products/500x500/des_20608.jpg",
    title: "Design No: 20608",
  },
  {
    image: "/products/500x500/des_20701.jpg",
    title: "Design No: 20701",
  },
  {
    image: "/products/500x500/des_20704.jpg",
    title: "Design No: 20704",
  },
  {
    image: "/products/500x500/des_20706.jpg",
    title: "Design No: 20706",
  },
  {
    image: "/products/500x500/des_20710.jpg",
    title: "Design No: 20710",
  },
  {
    image: "/products/500x500/des_20751.jpg",
    title: "Design No: 20751",
  },
  {
    image: "/products/500x500/des_20753.jpg",
    title: "Design No: 20753",
  },
  {
    image: "/products/500x500/des_20761.jpg",
    title: "Design No: 20761",
  },
  {
    image: "/products/500x500/des_20762.jpg",
    title: "Design No: 20762",
  },
  {
    image: "/products/500x500/des_20501.jpg",
    title: "Design No: 20501",
  },
  {
    image: "/products/500x500/des_20502.jpg",
    title: "Design No: 20502",
  },
  {
    image: "/products/500x500/des_20503.jpg",
    title: "Design No: 20503",
  },
  {
    image: "/products/500x500/des_20504.jpg",
    title: "Design No: 20504",
  },
  {
    image: "/products/500x500/des_20505.jpg",
    title: "Design No: 20505",
  },
  {
    image: "/products/500x500/des_20506.jpg",
    title: "Design No: 20506",
  },
  {
    image: "/products/500x500/des_20511.jpg",
    title: "Design No: 20511",
  },
  {
    image: "/products/500x500/des_20512.jpg",
    title: "Design No: 20512",
  },
  {
    image: "/products/500x500/des_20513.jpg",
    title: "Design No: 20513",
  },
  {
    image: "/products/500x500/des_20515.jpg",
    title: "Design No: 20515",
  },
  {
    image: "/products/500x500/des_20825.jpg",
    title: "Design No: 20825",
  },
  {
    image: "/products/500x500/des_20827.jpg",
    title: "Design No: 20827",
  },
  {
    image: "/products/500x500/des_20253.jpg",
    title: "Design No: 20253",
  },
  {
    image: "/products/500x500/des_20265.jpg",
    title: "Design No: 20265",
  },
  {
    image: "/products/500x500/des_20240.jpg",
    title: "Design No: 20240",
  },
  {
    image: "/products/500x500/des_20219.jpg",
    title: "Design No: 20219",
  },
  {
    image: "/products/500x500/des_20231.jpg",
    title: "Design No: 20231",
  },
  {
    image: "/products/500x500/des_20232.jpg",
    title: "Design No: 20232",
  },
];

export const PRODUCT_400_400 = [
  {
    image: "/products/400x400/des_5006.jpg",
    title: "Design No: 5006",
  },
  {
    image: "/products/400x400/des_5007.jpg",
    title: "Design No: 5007",
  },
  {
    image: "/products/400x400/des_5031.jpg",
    title: "Design No: 5031",
  },
  {
    image: "/products/400x400/des_5032.jpg",
    title: "Design No: 5032",
  },
  {
    image: "/products/400x400/des_5052.jpg",
    title: "Design No: 5052",
  },
  {
    image: "/products/400x400/des_5063.jpg",
    title: "Design No: 5063",
  },
  {
    image: "/products/400x400/des_5074.jpg",
    title: "Design No: 5074",
  },
  {
    image: "/products/400x400/des_5075.jpg",
    title: "Design No: 5075",
  },
  {
    image: "/products/400x400/des_5101.jpg",
    title: "Design No: 5101",
  },
  {
    image: "/products/400x400/des_5105.jpg",
    title: "Design No: 5105",
  },
  {
    image: "/products/400x400/des_5125.jpg",
    title: "Design No: 5125",
  },
  {
    image: "/products/400x400/des_5127.jpg",
    title: "Design No: 5127",
  },
  {
    image: "/products/400x400/des_5154.jpg",
    title: "Design No: 5154",
  },
  {
    image: "/products/400x400/des_5156.jpg",
    title: "Design No: 5156",
  },
  {
    image: "/products/400x400/des_5171.jpg",
    title: "Design No: 5171",
  },
  {
    image: "/products/400x400/des_5175.jpg",
    title: "Design No: 5175",
  },
  {
    image: "/products/400x400/des_5214.jpg",
    title: "Design No: 5214",
  },
  {
    image: "/products/400x400/des_5217.jpg",
    title: "Design No: 5217",
  },
  {
    image: "/products/400x400/des_5233.jpg",
    title: "Design No: 5233",
  },
  {
    image: "/products/400x400/des_5234.jpg",
    title: "Design No: 5234",
  },
  {
    image: "/products/400x400/des_5243.jpg",
    title: "Design No: 5243",
  },
  {
    image: "/products/400x400/des_5244.jpg",
    title: "Design No: 5244",
  },
  {
    image: "/products/400x400/des_5249.jpg",
    title: "Design No: 5249",
  },
  {
    image: "/products/400x400/des_5262.jpg",
    title: "Design No: 5262",
  },
  {
    image: "/products/400x400/des_5267.jpg",
    title: "Design No: 5267",
  },
  {
    image: "/products/400x400/des_5271.jpg",
    title: "Design No: 5271",
  },
  {
    image: "/products/400x400/des_5269.jpg",
    title: "Design No: 5269",
  },
  {
    image: "/products/400x400/des_5270.jpg",
    title: "Design No: 5270",
  },
  {
    image: "/products/400x400/des_5274.jpg",
    title: "Design No: 5274",
  },
  {
    image: "/products/400x400/des_5291.jpg",
    title: "Design No: 5291",
  },
  {
    image: "/products/400x400/des_5296.jpg",
    title: "Design No: 5296",
  },
  {
    image: "/products/400x400/des_5298.jpg",
    title: "Design No: 5298",
  },
  {
    image: "/products/400x400/des_5511.jpg",
    title: "Design No: 5511",
  },
  {
    image: "/products/400x400/des_5512.jpg",
    title: "Design No: 5512",
  },
  {
    image: "/products/400x400/des_5513.jpg",
    title: "Design No: 5513",
  },
  {
    image: "/products/400x400/des_5514.jpg",
    title: "Design No: 5514",
  },
  {
    image: "/products/400x400/des_5515.jpg",
    title: "Design No: 5515",
  },
  {
    image: "/products/400x400/des_5516.jpg",
    title: "Design No: 5516",
  },
  {
    image: "/products/400x400/des_5524.jpg",
    title: "Design No: 5524",
  },
  {
    image: "/products/400x400/des_5530.jpg",
    title: "Design No: 5530",
  },
  {
    image: "/products/400x400/des_5535.jpg",
    title: "Design No: 5535",
  },
  {
    image: "/products/400x400/des_5536.jpg",
    title: "Design No: 5536",
  },
  {
    image: "/products/400x400/des_5537.jpg",
    title: "Design No: 5537",
  },
  {
    image: "/products/400x400/des_5538.jpg",
    title: "Design No: 5538",
  },
  {
    image: "/products/400x400/des_5801.jpg",
    title: "Design No: 5801",
  },
  {
    image: "/products/400x400/des_5802.jpg",
    title: "Design No: 5802",
  },
  {
    image: "/products/400x400/des_5804.jpg",
    title: "Design No: 5804",
  },
  {
    image: "/products/400x400/des_5805.jpg",
    title: "Design No: 5805",
  },
  {
    image: "/products/400x400/des_5543.jpg",
    title: "Design No: 5543",
  },
  {
    image: "/products/400x400/des_5563.jpg",
    title: "Design No: 5563",
  },
  {
    image: "/products/400x400/des_5544.jpg",
    title: "Design No: 5544",
  },
  {
    image: "/products/400x400/des_5545.jpg",
    title: "Design No: 5545",
  },
  {
    image: "/products/400x400/des_6502.jpg",
    title: "Design No: 6502",
  },
  {
    image: "/products/400x400/des_8108.jpg",
    title: "Design No: 8108",
  },
  {
    image: "/products/400x400/des_8122.jpg",
    title: "Design No: 8122",
  },
  {
    image: "/products/400x400/des_8123.jpg",
    title: "Design No: 8123",
  },
  {
    image: "/products/400x400/des_8141.jpg",
    title: "Design No: 8141",
  },
  {
    image: "/products/400x400/des_8142.jpg",
    title: "Design No: 8142",
  },
  {
    image: "/products/400x400/des_8161.jpg",
    title: "Design No: 8161",
  },
  {
    image: "/products/400x400/des_8160.jpg",
    title: "Design No: 8160",
  },
  {
    image: "/products/400x400/des_8171.jpg",
    title: "Design No: 8171",
  },
  {
    image: "/products/400x400/des_8170.jpg",
    title: "Design No: 8170",
  },
  {
    image: "/products/400x400/des_5366.jpg",
    title: "Design No: 5366",
  },
  {
    image: "/products/400x400/des_5367.jpg",
    title: "Design No: 5367",
  },
  {
    image: "/products/400x400/des_5303.jpg",
    title: "Design No: 5303",
  },
  {
    image: "/products/400x400/des_5317.jpg",
    title: "Design No: 5317",
  },
  {
    image: "/products/400x400/des_5305.jpg",
    title: "Design No: 5305",
  },
  {
    image: "/products/400x400/des_5308.jpg",
    title: "Design No: 5308",
  },
  {
    image: "/products/400x400/des_5405.jpg",
    title: "Design No: 5405",
  },
  {
    image: "/products/400x400/des_5406.jpg",
    title: "Design No: 5406",
  },
  {
    image: "/products/400x400/des_5426.jpg",
    title: "Design No: 5426",
  },
  {
    image: "/products/400x400/des_5427.jpg",
    title: "Design No: 5427",
  },
  {
    image: "/products/400x400/des_5604.jpg",
    title: "Design No: 5604",
  },
  {
    image: "/products/400x400/des_5605.jpg",
    title: "Design No: 5605",
  },
  {
    image: "/products/400x400/des_7014.jpg",
    title: "Design No: 7014",
  },
  {
    image: "/products/400x400/des_7701.jpg",
    title: "Design No: 7701",
  },
  {
    image: "/products/400x400/des_7404.jpg",
    title: "Design No: 7404",
  },
  {
    image: "/products/400x400/des_7405.jpg",
    title: "Design No: 7405",
  },
  {
    image: "/products/400x400/des_7508.jpg",
    title: "Design No: 7508",
  },
  {
    image: "/products/400x400/des_7514.jpg",
    title: "Design No: 7514",
  },
  {
    image: "/products/400x400/des_7023.jpg",
    title: "Design No: 7023",
  },
  {
    image: "/products/400x400/des_7602.jpg",
    title: "Design No: 7602",
  },
  {
    image: "/products/400x400/des_7612.jpg",
    title: "Design No: 7612",
  },
  {
    image: "/products/400x400/des_7614.jpg",
    title: "Design No: 7614",
  },
  {
    image: "/products/400x400/des_7801.jpg",
    title: "Design No: 7801",
  },
  {
    image: "/products/400x400/des_7803.jpg",
    title: "Design No: 7803",
  },
  {
    image: "/products/400x400/des_7804.jpg",
    title: "Design No: 7804",
  },
  {
    image: "/products/400x400/des_7812.jpg",
    title: "Design No: 7812",
  },
  {
    image: "/products/400x400/des_7305.jpg",
    title: "Design No: 7305",
  },
  {
    image: "/products/400x400/des_7306.jpg",
    title: "Design No: 7306",
  },
  {
    image: "/products/400x400/des_7312.jpg",
    title: "Design No: 7312",
  },
  {
    image: "/products/400x400/des_7318.jpg",
    title: "Design No: 7318",
  },
  {
    image: "/products/400x400/des_7912.jpg",
    title: "Design No: 7912",
  },
  {
    image: "/products/400x400/des_7913.jpg",
    title: "Design No: 7913",
  },
  {
    image: "/products/400x400/des_7915.jpg",
    title: "Design No: 7915",
  },
  {
    image: "/products/400x400/des_7918.jpg",
    title: "Design No: 7918",
  },
  {
    image: "/products/400x400/des_6034.jpg",
    title: "Design No: 6034",
  },
  {
    image: "/products/400x400/des_6045.jpg",
    title: "Design No: 6045",
  },
  {
    image: "/products/400x400/des_6070.jpg",
    title: "Design No: 6070",
  },
  {
    image: "/products/400x400/des_6071.jpg",
    title: "Design No: 6071",
  },
  {
    image: "/products/400x400/des_6102.jpg",
    title: "Design No: 6102",
  },
  {
    image: "/products/400x400/des_6107.jpg",
    title: "Design No: 6107",
  },
  {
    image: "/products/400x400/des_6155.jpg",
    title: "Design No: 6155",
  },
  {
    image: "/products/400x400/des_6161.jpg",
    title: "Design No: 6161",
  },
  {
    image: "/products/400x400/des_6176.jpg",
    title: "Design No: 6176",
  },
  {
    image: "/products/400x400/des_6178.jpg",
    title: "Design No: 6178",
  },
  {
    image: "/products/400x400/des_6180.jpg",
    title: "Design No: 6180",
  },
  {
    image: "/products/400x400/des_6188.jpg",
    title: "Design No: 6188",
  },
  {
    image: "/products/400x400/des_6211.jpg",
    title: "Design No: 6211",
  },
  {
    image: "/products/400x400/des_6219.jpg",
    title: "Design No: 6219",
  },
  {
    image: "/products/400x400/des_6215.jpg",
    title: "Design No: 6215",
  },
  {
    image: "/products/400x400/des_6216.jpg",
    title: "Design No: 6216",
  },
  {
    image: "/products/400x400/des_9811.jpg",
    title: "Design No: 9811",
  },
  {
    image: "/products/400x400/des_9812.jpg",
    title: "Design No: 9812",
  },
  {
    image: "/products/400x400/des_9817.jpg",
    title: "Design No: 9817",
  },
];

export const SLIDES = [
  {
    img: "/slider/slider3.jpg",
    bottomLeftTitle: "WE ARE MANUFACTURING",
    bottomLeftSubtitle: "Heavy Duty Virtified Digital Parking Tiles 400x400mm & 500x500mm",
    downloadLink: "/catalogues/E_CATALOGUE_13_06_2025.pdf",
    productLink: routeConstant.CATALOGUE_400X400,
  },
  {
    img: "/slider/slider6.jpg",
    bottomLeftTitle: "Global Export",
    bottomLeftSubtitle: "Reaching every corner of the world",
    downloadLink: "/catalogues/E_CATALOGUE_13_06_2025.pdf",
    productLink: routeConstant.CATALOGUE_400X400,
  },
  {
    img: "/slider/slider10.jpg",
    bottomLeftTitle: "Premium Quality",
    bottomLeftSubtitle: "Top-notch materials and craftsmanship",
    downloadLink: "/catalogues/E_CATALOGUE_13_06_2025.pdf",
    productLink: routeConstant.CATALOGUE_400X400,
  },
  {
    img: "/slider/slider11.jpg",
    bottomLeftTitle: "Sustainable Innovation",
    bottomLeftSubtitle: "Eco-friendly and efficient solutions",
    downloadLink: "/catalogues/E_CATALOGUE_13_06_2025.pdf",
    productLink: routeConstant.CATALOGUE_400X400,
  }
];
